import styled from '@emotion/native';
import React from 'react';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import { IsDesktopProps } from '@/shared/styles/types';
import { Expertise, StylingPreference } from '@/shared/types/stylist';
import { FieldTitle } from '@/shared/styles/styledComponents/styledComponents';
import PreferenceButton from '../../../shared/components/PreferenceButton';

export type ButtonSelectItem = Expertise | StylingPreference;

export interface SelectButtonProps {
  selectedItems: ButtonSelectItem[];
  setSelectedItems: React.Dispatch<React.SetStateAction<ButtonSelectItem[]>>;
  enumArray: ButtonSelectItem[];
  fieldTitle: string;
  showDescription?: boolean;
}

const SelectButtons = ({
  selectedItems,
  setSelectedItems,
  enumArray,
  fieldTitle,
  showDescription = false,
}: SelectButtonProps) => {
  const isDesktop = useIsDesktop();

  return (
    <OuterContainer isDesktop={isDesktop}>
      {isDesktop && <FieldTitle>{fieldTitle}*</FieldTitle>}
      <InnerContainer isDesktop={isDesktop}>
        {enumArray.map((item) => (
          <PreferenceButton
            key={item}
            item={item}
            isSelected={selectedItems.includes(item)}
            isDesktop={isDesktop}
            onToggle={() =>
              setSelectedItems((prev: ButtonSelectItem[]) =>
                prev.includes(item)
                  ? prev.filter((arrayItem) => arrayItem !== item)
                  : [...prev, item],
              )
            }
            showDescription={showDescription}
          />
        ))}
      </InnerContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  padding: isDesktop ? 40 : 0,
}));

const InnerContainer = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  flexDirection: isDesktop ? 'row' : 'column',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  overflow: 'visible',
}));

export default SelectButtons;
